import React from 'react';
import './AppInfo.css';
import appIcon from './appicon.png';

const AppInfo: React.FC = () => {
  return (
    <section className="app-info">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-4 text-center">
            <img src={appIcon} alt="App Icon" className="rounded img-fluid app-icon" />
          </div>
          <div className="col-md-8 my-3">
            <h2>About Habitaly</h2>
            <p>Habitaly is an app designed to help you build and maintain daily habits. Track your progress, analyze your achievements, and make positive habits a part of your life. Habitaly is your reliable companion on the journey of self-improvement.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppInfo;
